import { createStore } from "vuex";
import _ from "lodash";

export default createStore({
  state: { trackings: {} },
  getters: {
    trackers(state) {
      const trackers = {
        camp: state.trackings.camp,
        idcamp: state.trackings.idcamp,
        vendor: state.trackings.vendor,
        kw: state.trackings.kw,
        IDadv: state.trackings.IDadv,
        gclid: state.trackings.gclid,
        codice: state.trackings.codice,
        ClickID: state.trackings.ClickID
      };
      return trackers;
    }
  },
  mutations: {
    setTrackers(state, payload) {
      const trackings = _.assign(state.trackings, payload);
      state.trackings = trackings;
    }
  },
  actions: {
    setTrackers(context, queryString) {
      context.commit("setTrackers", queryString);
    }
  },
  modules: {}
});
